import { ChangeEvent } from 'react'
import { useTranslation } from 'next-i18next'

import useSettingsFormContext from '~/hooks/useSettingsFormContext'
import { FieldError } from '~/components/FieldError'
import { SelectBoxHomGradient } from '~/components/SelectBoxHomGradient'

import { countryData } from '~/shared/constants/countryData.const'

export default function SchoolCountry(): React.ReactElement {
  const { t } = useTranslation(['studentPanel', 'booking'])
  const { fields, setFields, errors } = useSettingsFormContext()

  const handleOnChange = (event: ChangeEvent<HTMLSelectElement>): void => {
    setFields((prevState) => ({
      ...prevState,
      schoolCountry: event.target.value,
    }))
  }

  return (
    <div className="flex flex-col">
      <SelectBoxHomGradient name="schoolCountry" onChange={handleOnChange} value={fields.schoolCountry ?? ''}>
        <option value="">{t('studentPanel:settings.labelSchoolCountry')}</option>
        {countryData.map((elem) => (
          <option key={elem} value={elem}>
            {elem}
          </option>
        ))}
      </SelectBoxHomGradient>
      <FieldError error={errors.schoolCountry} />
    </div>
  )
}
